import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { fetchDeviceActInfo } from "../../appRedux/actions/common/configurationAction";
import AlertBox from "./alertBox";

function Reminder({ role, deviceInfo, authorisedMips, fetchDeviceActInfo }) {
  const [reminder, setReminder] = useState({
    message: "",
    isVisible: false,
    isDismissed: false,
  });
  const [remaining, setRemaining] = useState(0);

  useEffect(() => {
    function reminderMessage(deviceInfo) {
      if (deviceInfo && deviceInfo.deviceExpiry) {
        const expiryDate = new Date(deviceInfo.deviceExpiry);
        const todaysDate = new Date();
        const difference = expiryDate - todaysDate;
        const remainingDays = Math.ceil(difference / (1000 * 60 * 60 * 24));

        setRemaining(remainingDays);
        const dismissedDays = Number(Cookies.get("dismissedDays") || null);
        const daysMessage = remainingDays === 1 ? "day" : "days";

        if (remainingDays < 0 || deviceInfo.deviceStatus !== "ACTIVE") {
          setReminder({
            message: `PRODA device has expired.`,
            isVisible: true,
            isDismissed: false,
          });
        } else if (remainingDays === 0) {
          setReminder({
            message: `PRODA device "${deviceInfo.deviceName}" is expiring today.`,
            isVisible: true,
            isDismissed: false,
          });
        } else if (remainingDays <= 7) {
          setReminder({
            message: `PRODA device "${deviceInfo.deviceName}" will expire in ${remainingDays} ${daysMessage}.`,
            isVisible: true,
            isDismissed: false,
          });
        } else if (
          remainingDays <= 30 &&
          remainingDays > 15 &&
          dismissedDays != 30
        ) {
          setReminder({
            message: `PRODA device "${deviceInfo.deviceName}" will expire in ${remainingDays} ${daysMessage}.`,
            isVisible: true,
            isDismissed: false,
          });
        } else if (
          remainingDays <= 15 &&
          remainingDays > 7 &&
          dismissedDays !== 15
        ) {
          setReminder({
            message: `PRODA device "${deviceInfo.deviceName}" will expire in ${remainingDays} ${daysMessage}.`,
            isVisible: true,
            isDismissed: false,
          });
        }
      }
    }

   if (deviceInfo.data && Array.isArray(deviceInfo.data) && deviceInfo.data.length) {
  authorisedMips &&
    authorisedMips.length &&
    authorisedMips.forEach((mip) => {
      const device = deviceInfo.data.find(
        (device) => device.mipId === mip.mipId
      );

      if (device) {
        reminderMessage(device);
      }
    });
}
  }, [deviceInfo]);

  useEffect(() => {
    if (!deviceInfo.data) {
      fetchDeviceActInfo();
    }
  }, []);

  const handleDismiss = () => {
    setReminder((prev) => ({ ...prev, isDismissed: true }));

    if (remaining > 15) {
      Cookies.set("dismissedDays", 30, { expires: 30 });
    } else if (remaining > 7 && remaining <= 15) {
      Cookies.set("dismissedDays", 15, { expires: 30 });
    } else {
      Cookies.remove("dismissedDays");
    }
  };

  return (
      <>
      {!reminder.isDismissed && reminder.isVisible && (
        <div style={{ display: "flex", justifyContent: "center" }}>
        <AlertBox
          role={role}
          reminder={reminder}
          handleDismiss={handleDismiss}
          remaining={remaining}
        />
        </div>
      )}
      </>
  );
}

export const mapDispatchToProps = (dispatch) => ({
  fetchDeviceActInfo: bindActionCreators(fetchDeviceActInfo, dispatch),
});

const mapStateToProps = ({ config, auth }) => ({
  deviceInfo: config.deviceInfo,
  authorisedMips: auth && auth.authUser.mips,
});

export default connect(mapStateToProps, mapDispatchToProps)(Reminder);
